import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'faq-list-view',
  templateUrl: './faq-list-view.component.html',
  styleUrl: './faq-list-view.component.scss',
  standalone: false,
})
export class FrequentlyAskedQuestionsListViewComponent {
  @Input()
  set frequentlyAskedQuestions(frequentlyAskedQuestions: app.models.FAQModel[]) {
    this.renderedFrequentlyAskedQuestions = frequentlyAskedQuestions?.map(val => ({
      ...val,
      answer: this._sanitizer.bypassSecurityTrustHtml(val.answer),
    }));
  }
  @Input() props: app.models.DynamicPropsDictionary;

  renderedFrequentlyAskedQuestions!: {
    answer: SafeHtml;
    frequentlyAskedQuestionId: string;
    question: string;
    lastModified: Date;
  }[];

  constructor(private _sanitizer: DomSanitizer) {}
}
